export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Devo essere un insegnante di educazione fisica per usarlo?',
    answer:
      'No. Il pack è scritto per essere usato anche dal maestro di posto comune che insegna motoria nelle prime classi della primaria. Ogni esercizio è spiegato passo passo, con la frase esatta da dire alla classe.',
  },
  {
    question: 'Per quali classi è adatto?',
    answer:
      'Dalla 1ª primaria alla 5ª superiore. Gli 8 volumi coprono educazione motoria, educazione fisica e scienze motorie e sportive, con il linguaggio corretto per ciascun grado.',
  },
  {
    question: 'Funziona anche senza palestra e senza attrezzi?',
    answer:
      'Sì. Ogni unità dichiara la versione per palestra intera, mezza palestra, spazio esterno e aula, e gli esercizi sono pensati con materiale povero. Un bonus è dedicato interamente alle attività in aula e in corridoio.',
  },
  {
    question: 'Ricevo un file fisico o digitale?',
    answer:
      'Digitale. Ricevi subito i PDF pronti da stampare in formato A4, senza attese e senza spese di spedizione.',
  },
  {
    question: 'Segue le Indicazioni Nazionali?',
    answer:
      'Sì. I contenuti sono organizzati secondo i nuclei della materia e la progressione prevista per ciascun grado scolastico.',
  },
  {
    question: 'Include la valutazione?',
    answer:
      'Sì. Ogni volume contiene griglie di osservazione, rubriche a 4 livelli e, per medie e superiori, i descrittori con la corrispondenza al voto in decimi già scritti.',
  },
  {
    question: 'Cosa succede se non mi piace?',
    answer: 'Hai 30 giorni per chiedere il rimborso completo, senza dover spiegare il motivo.',
  },
]
